// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;The charge he laid on the people of Joseph,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;when they came out of the land of Egypt.<br> </p> </div></div>";
// Exports
module.exports = code;